import axios from 'axios';
import axiosRetry from 'axios-retry';
import getConfig from 'next/config';

import { setupInterceptors } from '.';

const { publicRuntimeConfig } = getConfig();

const experimentationIdUrl = `${publicRuntimeConfig.experimentationIdHost}/api/v1/sync`;
const apiToken = Buffer.from(
  `${publicRuntimeConfig.experimentationIdSecret}:`
).toString('base64');

const axiosClient = axios.create();
axiosRetry(axiosClient, {
  retryDelay: axiosRetry.exponentialDelay
});
setupInterceptors(axiosClient);

export async function sync(
  anonymousId: string,
  userId: string,
  traits: Record<string, unknown>
) {
  await axiosClient.post(
    experimentationIdUrl,
    {
      anonymousId,
      traits,
      userId
    },
    {
      headers: {
        Authorization: apiToken
      }
    }
  );
}

export default {
  sync
};
